<!-- prettier-ignore -->

<div class="list-pdf-container">
    <h1>{{'Información seleccionada' | translate}}</h1>
    <div class="list-pdf-container__pdfs">
        @for (pdf of pdfs(); track pdf) {
            @if(pdfsSelectedIds()?.includes(pdf?.id)){
                <cicerone-generic-card [item]="pdf" [isPdfCheckbox]="true" [isSelected]="true" (pdfEmitter)="removePdf($event)"></cicerone-generic-card>
            }
        }
    </div>
    <div class="list-pdf-container__button-container">
        <button (click)="toggleView()">{{'Añadir PDFs' | translate}}</button>
    </div>
</div> 